export default "__VITE_ASSET__74e015ed__"